export function getdata() {
	let obj ={
		headData: [
			{
				title: "差异原因",
				prop: "cyyy",
				width: "100px",
				custom: true,
			},
			{
				title: "差异金额",
				prop: "cyje",
				width: "55px",
				custom: true,
			}
			
		],
		tableData:{
		},
	}
	return obj 
}
